export default "__VITE_ASSET__DGPydTBh__"